import { Files } from '../../lib/constants/files'
import { ScoreCard } from '../../lib/types/models/score-card/score-card'
import { ScoreCardInput } from '../../lib/types/models/score-card/score-card-input'
import { NullableTransformer, UpdateInput } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const updateScoreCard = async ({ id, ...data }: UpdateInput<ScoreCardInput>) => {
  const video = await uploadFile(Files.CANDIDATE_INTERVIEW, data.video)
  const transcript = await uploadFile(Files.CANDIDATE_INTERVIEW, data.transcript)

  return restApiClient
    .url(constructApiUrl(API.scoreCards.update.url, { id }))
    .patch<ScoreCard, NullableTransformer<Partial<ScoreCardInput>>>({ ...data, video, transcript })
}
